import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import ThemeContext from '../../context/theme/themeContext';
import { getLatestPatchNotesPreview } from '../../utils/patchNotesData';
import './customHome.css';

const Home = () => {
  const authContext = useContext(AuthContext);
  const { isAuthenticated, loadUser } = authContext;
  const { isDarkMode } = useContext(ThemeContext);
  const [latestPatchNotes, setLatestPatchNotes] = useState(null);

  useEffect(() => {
    // Load latest patch notes
    const patchNotes = getLatestPatchNotesPreview();
    setLatestPatchNotes(patchNotes);
  }, []);

  const renderAuthenticatedContent = () => (
    <div className="home-page">
      <div className="card">
        <div className="home-logo">
          <img
            src={isDarkMode ? '/Logo-with-slogan-darkmode.png' : '/Logo-with-slogan.png'}
            alt="PokeMatch Logo"
          />
        </div>
        <h1>Welcome to PokeMatch!</h1>

        {latestPatchNotes && (
          <div className="patch-notes-section">
            <h2>Latest Updates - v{latestPatchNotes.version}</h2>
            <h3>{latestPatchNotes.title}</h3>
            <div className="patch-preview">
              <pre>{latestPatchNotes.preview}</pre>
            </div>
            <Link to="/patch-notes" className="btn btn-outline patch-notes-btn">View All Updates</Link>
          </div>
        )}

        <div className="stats-container">
          <div className="stat-card">
            <i className="fas fa-plus-circle"></i>
            <h2 className="stat-title">Log <br /><span>Match</span></h2>
            <p>Record your match details and results</p>
            <Link to="/dashboard" className="btn btn-primary btn-block">
              Log New Match
            </Link>
          </div>

          <div className="stat-card">
            <i className="fas fa-chart-line"></i>
            <h2 className="stat-title">Dashboard</h2>
            <p>View your match history and statistics</p>
            <Link to="/dashboard" className="btn btn-primary btn-block">
              View Dashboard
            </Link>
          </div>

          <div className="stat-card">
            <i className="fas fa-history"></i>
            <h2 className="stat-title">Match <br /><span>History</span></h2>
            <p>Browse and filter your past matches</p>
            <Link to="/dashboard" className="btn btn-primary btn-block">
              View History
            </Link>
          </div>

          <div className="stat-card">
            <i className="fas fa-download"></i>
            <h2 className="stat-title">Export <br /><span>Data</span></h2>
            <p>Download your match data in CSV format</p>
            <Link to="/dashboard" className="btn btn-primary btn-block">
              Export Data
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  const renderGuestContent = () => (
    <div className="home-page">
      <div className="card">
        <div className="home-logo home-logo--guest">
          <img
            src={isDarkMode ? '/Logo-with-slogan-darkmode.png' : '/Logo-with-slogan.png'}
            alt="PokeMatch Logo"
          />
        </div>
        <p className="home-hero-pitch">Track your Pokemon Trading Card Game matches, analyze your performance, and improve your gameplay with powerful insights and statistics.</p>

        {latestPatchNotes && (
          <div className="patch-notes-section">
            <h2>Latest Updates - v{latestPatchNotes.version}</h2>
            <h3>{latestPatchNotes.title}</h3>
            <div className="patch-preview">
              <pre>{latestPatchNotes.preview}</pre>
            </div>
            <Link to="/patch-notes" className="btn btn-outline patch-notes-btn">View All Updates</Link>
          </div>
        )}

        <div className="features grid-2">
          <div className="feature">
            <i className="fas fa-clipboard-list"></i>
            <h3>Match Tracking</h3>
            <p>Keep detailed records of your Pokemon TCG matches including opponent decks, match formats, and game results.</p>
          </div>

          <div className="feature">
            <i className="fas fa-chart-pie"></i>
            <h3>Performance Analytics</h3>
            <p>View comprehensive statistics and identify patterns in your gameplay to help improve your win rate.</p>
          </div>

          <div className="feature">
            <i className="fas fa-lightbulb"></i>
            <h3>Gameplay Insights</h3>
            <p>Get insights on matchups, coin flip advantages, and first-turn strategies based on your match history.</p>
          </div>

          <div className="feature">
            <i className="fas fa-download"></i>
            <h3>Data Export</h3>
            <p>Export your match data to CSV format for further analysis in your preferred spreadsheet application.</p>
          </div>
        </div>

        <div className="buttons">
          <Link to="/register" className="btn btn-primary btn-lg">
            Create Account
          </Link>
          <Link to="/login" className="btn btn-outline btn-lg">
            Login
          </Link>
        </div>
      </div>
    </div>
  );

  return isAuthenticated ? renderAuthenticatedContent() : renderGuestContent();
};

export default Home;